import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppConstant } from '@app/shared/constants';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class TeamService {

  constructor(private httpClient: HttpClient) { }

  getCompanyMembers(companyId: number) {
    return this.httpClient.get(environment.baseUrl + AppConstant.GET_COMPANY_MEMBERS + companyId);
  }
  getInvitedMembers(companyId: number) {
    return this.httpClient.get(environment.baseUrl + AppConstant.GET_INVITED_MEMBERS + companyId);
  }
  sendInvite(payload: any) {
    return this.httpClient.post(environment.baseUrl + AppConstant.SEND_INVITE,payload);
  }
  updatePermission(payload: any){
    return this.httpClient.post(environment.baseUrl + AppConstant.UPDATE_PERMISSION,payload);
  }
  GetPermissionList(userId: number) {
    return this.httpClient.get(environment.baseUrl + AppConstant.GET_PERMISSION_LIST + userId);
  }
  deleteUser(userId: number) {
    return this.httpClient.get(environment.baseUrl + AppConstant.DELETE_USER + userId);
  }
  deactivateUser(userId: number) {
    return this.httpClient.get(environment.baseUrl + AppConstant.DEACTIVATE_USER + userId);
  }
}
